<template>
  <div class="pa-6" style="background-color: #070707">
    <v-container v-if="expoData">
      <v-row class="flex-nowrap">
        <!-- TODO: FIX THE BACK ARROW OVERLAP -->
        <v-col
          style="
            flex: 0 0 66.666667%;
            max-width: 66.6666666667%;
            align-self: flex-start;
          "
          ref="space_map"
        >
          <v-card class="b-rad-24 overflow-hidden" color="neutral800">
            <v-card-title class="d-flex align-center text-16px pt-1 pb-3">
              {{ $t('SPACE.EDIT.WORD.MAP') }}
              <v-spacer></v-spacer>
              <SizeBox width="32" />
              <v-checkbox
                :label="$t('SPACE.EDIT.WORD.MEASUREMENT')"
                v-model="isMarked"
                class="mt-0"
                dense
                hide-details
              ></v-checkbox>
            </v-card-title>
            <v-card-text class="pa-5">
              <v-card outlined>
                <v-img
                  :aspect-ratio="editorImageAspectRatio"
                  :src="isMarked ? editorMarkedImage.url : editorImage.url"
                  class="pos-r"
                >
                  <div
                    class="spawn_point pos-a text-center"
                    :style="{
                      top: spawnPoint.yPercent,
                      left: spawnPoint.xPercent
                    }"
                  >
                    <div>
                      <v-icon>mdi-flag</v-icon>
                    </div>
                    <div>{{ $t('ARTWORK.EDIT.WORD.BEGIN') }}</div>
                  </div>

                  <v-menu v-for="(dot, index) in dots" :key="index">
                    <template #activator="{ on }">
                      <v-hover
                        @input="
                          (v) => {
                            highlightListItem(v, index);
                            handleListHover({ hover: v, data: dot });
                          }
                        "
                      >
                        <v-btn
                          v-on="on"
                          :ref="`dot`"
                          :data-index="`dot-${dot.index}`"
                          class="dot"
                          :width="dotSize"
                          :height="dotSize"
                          :color="getDotColor(dot)"
                          depressed
                          fab
                          :style="{
                            top: dot.yPercent,
                            left: dot.xPercent
                          }"
                        >
                          <!-- <v-icon color="netural050" size="16">
                            {{ getDotIcon(dot) }}
                          </v-icon> -->
                          <i class="v-icon" :class="getDotIcon(dot)"></i>
                        </v-btn>
                      </v-hover>
                    </template>

                    <v-card>
                      <v-list>
                        <template v-if="dot && dot.data">
                          <v-list-item
                            @click="openUploadWorkFrame(dot)"
                            color="error"
                          >
                            <v-icon size="18" class="mr-1">mdi-pencil</v-icon>
                            {{ $t('COMMON.WORD.EDIT') }}
                          </v-list-item>
                          <v-list-item
                            @click="confirmDelete(dot)"
                            color="error"
                          >
                            <v-icon size="18" class="mr-1">
                              mdi-trash-can-outline
                            </v-icon>
                            {{ $t('COMMON.WORD.DELETE') }}
                          </v-list-item>
                        </template>
                        <template v-else>
                          <template v-if="/keyVision/.test(dot && dot.type)">
                            <v-list-item @click="openUploadWorkFrame(dot)">
                              <v-icon color="pink200">mdi-circle</v-icon>
                              {{ $t('COMMON.WORD.ADD') }}
                              {{
                                dot.type === 'keyVision'
                                  ? $t('ARTWORK.EDIT.WORD.KEY_VISION')
                                  : $t('ARTWORK.EDIT.WORD.STAGE_MODEL')
                              }}
                            </v-list-item>
                          </template>
                          <template v-else>
                            <v-list-item @click="openUploadWorkFrame(dot)">
                              <v-icon color="primary">mdi-circle</v-icon>
                              {{ $t('ARTWORK.EDIT.WORD.ADD_NEW_ITEM') }}
                            </v-list-item>
                            <v-list-item @click="openUploadPosterFrame(dot)">
                              <v-icon color="green200">mdi-circle</v-icon>
                              {{ $t('ARTWORK.EDIT.WORD.ADD_WALLPAPER') }}
                            </v-list-item>
                          </template>
                        </template>
                      </v-list>
                    </v-card>
                  </v-menu>

                  <v-menu
                    bottom
                    absolute
                    :value="!!displaying"
                    :position-x="menuX - hoverCard.width / 2 + dotSize / 2"
                    :position-y="menuY + dotSize + /* offsetY */ 4"
                  >
                    <v-card
                      class="pa-1"
                      v-if="displaying && hoverCardContent"
                      :width="hoverCard.width"
                      light
                    >
                      <v-img
                        :src="hoverCardContent.img"
                        contain
                        class="elevation-3"
                      ></v-img>
                      <SizeBox height="4" />
                      <div class="px-3 text-center text-truncate">
                        {{ hoverCardContent.name }}
                      </div>
                    </v-card>
                  </v-menu>
                </v-img>
              </v-card>
            </v-card-text>
          </v-card>
        </v-col>
        <v-spacer></v-spacer>
        <v-col style="flex: 0 0 29%; max-width: 29%">
          <v-card
            class="b-rad-24 overflow-hidden artwork_list no-shadow"
            color="neutral800"
            :class="`m-h${LIST_BOX_MAX_H}vh`"
            :style="{ height: LIST_BOX_MAX_H + 'px' }"
          >
            <v-list color="neutral800" style="border-radius: initial">
              <v-list-item class="text-16px pl-5 pr-5 flex-wrap">
                <v-icon class="mr-2" size="18">mdi-cog-outline</v-icon>
                {{ $t('SPACE.EDIT.WORD.SPACE_THEME') }}
              </v-list-item>
              <SizeBox height="12" />
              <v-divider></v-divider>
              <v-list-item class="pt-2 pb-2 pl-5 pr-5 flex-wrap">
                <p class="text-16px">{{ $t('ARTWORK.EDIT.WORD.ITEM_LIST') }}</p>
                <v-text-field
                  v-model="search"
                  prepend-inner-icon="mdi-magnify"
                  :placeholder="$t('ARTWORK.EDIT.WORD.SEARCH_ITEM')"
                  class="my-2 text-14px w100p"
                  hide-details
                  clearable
                  solo
                  rounded
                  dense
                  :background-color="'#353537'"
                ></v-text-field>
              </v-list-item>

              <v-divider></v-divider>

              <template v-if="hasNoWorks">
                <div class="d-flex align-start text-justify pa-5">
                  <v-icon>mdi-upload</v-icon>
                  <SizeBox width="24" />
                  <!-- 目前暫無任何已上傳檔案，你可以透過展場作品地圖上的「+」來在該點位新增作品、主視覺、壁貼。 -->
                  {{ $t('ARTWORK.EDIT.COPYWRITING.NO_UPLOADED_ITEMS') }}
                </div>
              </template>
              <div
                v-else
                id="SIDE_LIST"
                class="overflow-auto"
                :style="{ maxHeight: LIST_BOX_MAX_H - 137 + 'px' }"
              >
                <SideList
                  :title="$t('ARTWORK.EDIT.WORD.KEY_VISION')"
                  color="pink200"
                  v-model="highlightingListItem"
                  :list="keyVisions"
                  :search="search"
                  @hover="handleListHover"
                  @list-click="openUploadWorkFrame"
                  @delete="confirmDelete"
                />

                <v-divider></v-divider>

                <SideList
                  :title="$t('ARTWORK.EDIT.WORD.ITEM')"
                  color="primary"
                  v-model="highlightingListItem"
                  :list="artworks"
                  :search="search"
                  @hover="handleListHover"
                  @list-click="openUploadWorkFrame"
                  @delete="confirmDelete"
                />

                <v-divider></v-divider>

                <SideList
                  :title="$t('ARTWORK.EDIT.WORD.WALLPAPER')"
                  color="green200"
                  v-model="highlightingListItem"
                  :list="wallVisions"
                  :search="search"
                  @hover="handleListHover"
                  @list-click="openUploadPosterFrame"
                  @delete="confirmDelete"
                />
              </div>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <UploadPoster
      v-model="isUploadPosterFrameOpen"
      :work-data="passingData"
      @save="updateWork"
    />

    <UploadSteper
      v-model="isUploadFrameOpen"
      :work-data="passingData"
      @save="updateWork"
    />

    <UploadKeyVision
      v-model="isUpladKeyVisionFrameOpen"
      :work-data="passingData"
      :keyVisionSpec="keyVisionSpec"
      @save="updateWork"
    />

    <UploadKeyVision3D
      v-model="isUpladKeyVision3DFrameOpen"
      :work-data="passingData"
      @save="updateWork"
    />
  </div>
</template>

<script>
import UploadSteper from '@/components/exhibitions/_expoId/UploadStepper.vue';
import UploadKeyVision from '@/components/exhibitions/_expoId/UploadKeyVision.vue';
import UploadPoster from '@/components/exhibitions/_expoId/UploadPoster.vue';
import { mergeDeep } from '@/plugins/mergeDeep';
import SideList from './Map/SideList.vue';
import { deleteAsset } from '@/api/panel/exhibitions';
import UploadKeyVision3D from './UploadKeyVision3D.vue';

export default {
  components: {
    UploadSteper,
    UploadKeyVision,
    UploadPoster,
    SideList,
    UploadKeyVision3D
  },

  props: {
    expoData: {
      type: Object,
      default: null,
      required: true
    }
  },

  data() {
    return {
      keyVisionSpec: {
        aspectRatio: 2 / 1,
        limitHeight: 2000,
        limitWidth: 1000
      },

      isMarked: false,
      isUploadFrameOpen: false,
      isUploadPosterFrameOpen: false,
      isUpladKeyVisionFrameOpen: false,
      isUpladKeyVision3DFrameOpen: false,
      highlightingListItem: null,

      passingData: {},
      dots: {},
      keyVisions: [],
      artworks: [],
      wallVisions: [],
      menuX: 0,
      menuY: 0,
      search: '',

      hoverCard: {
        width: 152
      },
      dotSize: 22,

      displaying: null,

      subMenu: {
        isOpen: false,
        x: 0,
        y: 0
      },
      LIST_BOX_MAX_H: 72
    };
  },

  computed: {
    hasNoWorks() {
      return (
        !this.keyVisions.length &&
        !this.artworks.length &&
        !this.wallVisions.length
      );
    },
    editorImage() {
      return this.expoData.scene.editorImage || {};
    },
    editorMarkedImage() {
      return this.expoData.scene.editorMarkedImage || {};
    },
    editorImageAspectRatio() {
      return this.editorImage.width / this.editorImage.height;
    },
    spawnPoint() {
      if (!this.expoData.scene.settingJson) return {};
      const point = this.expoData.scene.settingJson.editorSpawnProjection;

      return {
        ...point,
        xPercent: `${(point.x / this.editorImage.width) * 100}%`,
        yPercent: `${(point.y / this.editorImage.height) * 100}%`
      };
    },
    hoverCardContent() {
      if (!this.displaying) return null;
      const showData = this.dots[this.displaying.index].data;
      if (!showData) return null;
      const img =
        showData.previewedImage ||
        showData.keyVisionImage ||
        showData.wallVisionImage ||
        {};
      const name = showData.artworkName || showData.name;
      return { img: img.url, name };
    }
  },

  watch: {
    isUploadFrameOpen(v) {
      if (!v) this.passingData = {};
    },
    isUploadPosterFrameOpen(v) {
      if (!v) this.passingData = {};
    },
    isUpladKeyVisionFrameOpen(v) {
      if (!v) this.passingData = {};
    },
    'subMenu.isOpen': {
      handler(v) {
        if (!v) this.passingData = {};
      }
    }
  },

  mounted() {
    this.parseDots();
    this.filterDots();
    this.initListHeight();
  },

  methods: {
    initListHeight() {
      this.LIST_BOX_MAX_H = this.$refs.space_map.clientHeight - 30;
    },
    parseDots(data = this.expoData.scene.settingJson) {
      const output = {};
      if (data) {
        data.editorAssetProjections.forEach((dot) => {
          if (dot.type === 'keyVision') {
            const ratio = (dot.ratio || '2:1').split(':');
            const calcedRatio = Number(ratio[0]) / Number(ratio[1]);

            dot.ratio &&
              this.$set(this.keyVisionSpec, 'aspectRatio', calcedRatio);
            dot.limitHeight &&
              this.$set(this.keyVisionSpec, 'limitHeight', dot.limitHeight);
            dot.limitWidth &&
              this.$set(this.keyVisionSpec, 'limitWidth', dot.limitWidth);
          }

          output[dot.index] = {
            ...dot,
            xPercent: `${(dot.x / this.editorImage.width) * 100}%`,
            yPercent: `${(dot.y / this.editorImage.height) * 100}%`
          };
        });
      }

      this.dots = output;
    },
    filterDots(data = this.expoData.assets) {
      data.forEach((dot) => this.setDotAsset(dot));
      const keyVisions = data.filter(
        (dot) => dot.type === 'keyVision' || dot.type === 'keyVision3D'
      );
      const wallVisions = data.filter((dot) => dot.type === 'wallVision');
      const artworks = data.filter(
        (dot) =>
          dot.type !== 'keyVision' &&
          dot.type !== 'keyVision3D' &&
          dot.type !== 'wallVision'
      );

      this.keyVisions = keyVisions;
      this.artworks = artworks;
      this.wallVisions = wallVisions;
    },
    setDotAsset(dot) {
      this.$set(this.dots, dot.index, mergeDeep(this.dots[dot.index], dot));
    },
    openDotSubMenu(dot, event) {
      this.passingData = dot;
      this.subMenu.isOpen = true;
      this.subMenu.x = event.pageX;
      this.subMenu.y = event.pageY;
    },
    openUploadWorkFrame(dot) {
      this.passingData = dot;
      if (dot.type === 'wallVision') {
        this.openUploadPosterFrame(dot);
      } else if (dot.type === 'keyVision') {
        this.isUpladKeyVisionFrameOpen = true;
      } else if (dot.type === 'keyVision3D') {
        if (
          !this.$store.getters['auth/getTeam'].permission
            .allowToCreateKeyVision3D
        ) {
          this.$store.dispatch('modal/ACTIVE_MODAL', {
            title: this.$t(
              'ARTWORK.EDIT.TOAST.SUCCESS.STAGE_NOT_AVAILABLE_FOR_REPLACEMENT'
            ),
            content:
              // '展間舞台更換上傳 3D 模型為升級方案功能\n如要使用需升級您的方案',
              this.$t(
                'ARTWORK.EDIT.COPYWRITING.UPGRADE_PLAN_ENABLE_REPLACEMENT_3D_MODEL'
              ) +
              '\n' +
              this.$t('SPACE.COPYWRITING.PLEASE_UPGRADE_YOUR_PLAN'),
            single: true,
            action: {
              text: this.$t('COMMON.WORD.UPGRADE'),
              bind: {
                outlined: false,
                color: 'primary'
              },
              callback: () => {
                this.$router.push('/update-account');
              }
            },
            cancel: {
              text: this.$t('COMMON.WORD.CANCEL')
            }
          });
          return;
        }
        this.isUpladKeyVision3DFrameOpen = true;
      } else {
        this.isUploadFrameOpen = true;
      }
    },
    openUploadPosterFrame(dot) {
      this.passingData = dot;

      this.isUploadPosterFrameOpen = true;
    },
    addWork(dot) {
      //
    },
    confirmDelete(artWork = this.passingData) {
      this.$store.dispatch('modal/ACTIVE_MODAL', {
        title: this.$t('ARTWORK.EDIT.POPUP.COPYWRITING.CONFIRM_DELETE'),
        content: this.$t(
          'ARTWORK.EDIT.POPUP.COPYWRITING.UNABLE_TO_RESTORE_AFTER_DELETE'
        ),
        action: {
          text: this.$t('COMMON.WORD.DELETE'),
          color: 'primary',
          callback: () => this.doDelete(artWork)
        },
        cancel: {
          text: this.$t('COMMON.WORD.CANCEL')
        }
      });
    },
    async doDelete(artWork = this.passingData) {
      let data = { ...artWork };
      data.id = this.expoData.id;
      const { error } = await deleteAsset(data);
      if (!error) {
        if (artWork.type === 'keyVision' || artWork.type === 'keyVision3D') {
          const idx = this.keyVisions.findIndex(
            ({ index }) => artWork.index === index
          );
          this.keyVisions.splice(idx, 1);
        } else if (artWork.type === 'wallVision') {
          const idx = this.wallVisions.findIndex(
            ({ index }) => artWork.index === index
          );
          this.wallVisions.splice(idx, 1);
        } else {
          const idx = this.artworks.findIndex(
            ({ index }) => artWork.index === index
          );
          this.artworks.splice(idx, 1);
        }

        let type = '';
        if (artWork.type === 'keyVision') type = 'keyVision';
        else if (artWork.type === 'keyVision3D') type = 'keyVision3D';

        this.$set(this.dots, artWork.index, {
          index: this.dots[artWork.index].index,
          type,
          x: this.dots[artWork.index].x,
          xPercent: this.dots[artWork.index].xPercent,
          y: this.dots[artWork.index].y,
          yPercent: this.dots[artWork.index].yPercent
        });
        this.$toast(this.$t('ARTWORK.EDIT.TOAST.SUCCESS.DELETE_SUCCESSFUL'));
      } else {
        console.error(error);
        this.$toast.error(this.$t('ARTWORK.EDIT.TOAST.ALERT.DELETE_FAIL'));
      }

      this.$store.dispatch('modal/CLOSE_MODAL');
    },
    getDotColor(dot) {
      if (dot.type === 'keyVision' || dot.type === 'keyVision3D') {
        return 'pink200';
      }
      if (dot.type === 'wallVision') {
        return 'green200';
      }
      if (dot.data) return 'primary';
      return 'neutral500';
    },
    getDotIcon(dot) {
      if (dot.type === 'keyVision' && dot.data) return 'icon_post_outlined_w';
      if (dot.type === 'keyVision3D' && dot.data)
        return 'icon_stage_outlined_w';
      if (dot.type === 'wallVision') {
        return 'icon_note_outlined_w';
      }
      if (dot.type === 'staticArtwork') {
        return 'icon_photo_outlined_w';
      }
      if (dot.type === 'musicArtwork') {
        return 'icon_pod_outlined_w';
      }
      if (dot.type === 'videoArtwork') {
        return 'icon_video_outlined_w';
      }
      if (dot.type === 'modelArtwork') {
        return 'icon_box_outlined_w';
      }
      if (dot.type === 'websiteArtwork') {
        return 'icon_webpage_outlined_w';
      }
      return 'icon_cross_w';
    },
    updateWork(work) {
      this.setDotAsset(work);
      const sortWork = (arr) => {
        let idx = arr.findIndex(({ index }) => index == work.index);
        if (idx > -1) {
          this.$set(arr, idx, mergeDeep(arr[idx], work));
        } else {
          arr.push(work);
        }
      };

      if (work.type === 'keyVision' || work.type === 'keyVision3D') {
        sortWork(this.keyVisions);
      } else if (work.type === 'wallVision') {
        sortWork(this.wallVisions);
      } else {
        sortWork(this.artworks);
      }
    },
    handleListHover({ hover: v, data: dot }) {
      this.displaying = v ? dot : null;
      const targetDot = document.querySelector(
        `[data-index="dot-${dot.index}"]`
      );
      if (!targetDot) return;
      const { x, y } = targetDot.getBoundingClientRect();
      this.menuX = x;
      this.menuY = y;
    },
    highlightListItem(v, dot) {
      if (!v) this.$nextTick(() => (this.highlightingListItem = null));
      this.highlightingListItem = Number(dot);
    }
  }
};
</script>

<style lang="scss" scoped>
.dot {
  position: absolute;
  transform: translate(-50%, -50%);
}
::v-deep {
  .col {
    background-color: $neutral800;
    border-radius: 20px;
  }
  .v-input {
    label {
      font-size: 14px;
    }
  }
}
.artwork_list {
  ::v-deep {
    .v-list {
      padding: 12px 0;
    }
    .v-list-item {
      min-height: 30px;
    }
    .v-input__prepend-inner {
      .v-icon.v-icon {
        color: $neutral400;
        font-size: 19px;
        margin-top: 2px;
      }
    }
    .v-input--is-focused {
      .v-input__prepend-inner {
        .v-icon.v-icon {
          color: #fff !important;
        }
      }
      .v-input__append-inner {
        button {
          color: #fff !important;
        }
      }
    }
  }
}
.v-icon.v-icon::before {
  content: '';
  background-size: contain;
  display: inline-block;
  font-size: inherit;
  text-rendering: auto;
  line-height: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 14px;
  height: 14px;
}
.icon_cross_w {
  &:before {
    background-image: url(~@/assets/icons/map/icon_cross_w.svg);
  }
}
.icon_note_outlined_w {
  &::before {
    background-image: url(~@/assets/icons/map/icon_note_outlined_w.svg);
  }
}
.icon_youtube_outlined_w {
  &::before {
    background-image: url(~@/assets/icons/map/icon_youtube_outlined_w.svg);
  }
}
.icon_stage_outlined_w {
  &::before {
    background-image: url(~@/assets/icons/map/icon_stage_outlined_w.svg);
  }
}
.icon_IPFS_outlined_w {
  &::before {
    background-image: url(~@/assets/icons/map/icon_IPFS_outlined_w.svg);
  }
}
.icon_webpage_outlined_w {
  &::before {
    background-image: url(~@/assets/icons/map/icon_webpage_outlined_w.svg);
  }
}
.icon_box_outlined_w {
  &::before {
    background-image: url(~@/assets/icons/map/icon_box_outlined_w.svg);
  }
}
.icon_post_outlined_w {
  &::before {
    background-image: url(~@/assets/icons/map/icon_post_outlined_w.svg);
  }
}
.icon_pod_outlined_w {
  &::before {
    background-image: url(~@/assets/icons/map/icon_pod_outlined_w.svg);
  }
}
.icon_photo_outlined_w {
  &::before {
    background-image: url(~@/assets/icons/map/icon_photo_outlined_w.svg);
  }
}
.icon_video_outlined_w {
  &::before {
    background-image: url(~@/assets/icons/map/icon_video_outlined_w.svg);
  }
}
</style>